import React from "react";

const PrivacyPolicyPage = () => {
  return (
    <div className="privacy-policy-area space">
      <div className="container">
        <h4 className="mb-4">Privacy Policy</h4>
        <p>
          At Gowrisankar Agencies, we are committed to protecting your privacy. This Privacy Policy outlines how we collect, use, and safeguard your personal information when you visit our website or use our services.
        </p>

        <h6>1. Information We Collect</h6>
        <p>
          We may collect personal information such as your name, email address, phone number, and address when you contact us, make a purchase, or fill out a form on our website.
        </p>

        <h6>2. How We Use Your Information</h6>
        <p>
          The information we collect is used to:
          <ul>
            <li style={{listStyleType:"none"}}>Respond to inquiries and provide customer support</li>
            <li style={{listStyleType:"none"}}>Process transactions and deliver products</li>
            <li style={{listStyleType:"none"}}>Improve our services and user experience</li>
            <li style={{listStyleType:"none"}}>Send updates, offers, and promotions (only with your consent)</li>
          </ul>
        </p>

        <h6>3. Data Protection</h6>
        <p>
          We implement industry-standard security measures to protect your data. Your personal information is stored securely and is not shared with third parties except for order fulfillment or when required by law.
        </p>

        <h6>4. Cookies</h6>
        <p>
          Our website may use cookies to enhance user experience and analyze traffic. You can disable cookies in your browser settings.
        </p>

        <h6>5. Third-Party Services</h6>
        <p>
          We may use third-party services like payment gateways or analytics tools. These providers have their own privacy policies, which we recommend reviewing.
        </p>

        <h6>6. Your Rights</h6>
        <p>
          You have the right to access, modify, or delete your personal data at any time. Please contact us if you wish to make such a request.
        </p>

        <h6>7. Contact Us</h6>
        <p>
          If you have any questions about this Privacy Policy, please contact us at:  
          <br />
          <strong>Email:</strong> <a href="mailto:rajesh.katakam@gmail.com">rajesh.katakam@gmail.com</a>  
          <br />
          <strong>Phone:</strong> <a href="tel:09248022760">092480 22760</a>
        </p>

        <p className="mt-4">
          This Privacy Policy was last updated on June 13, 2025.
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
